module.exports = __webpack_public_path__ + "public/images/stands-contact-1.ca8204e271cb17df09974fbf5e94faf1.webp";